module.exports = __webpack_public_path__ + "static/media/4.17af440b.jpeg";